import MainNav from './modules/main-nav';
import Share from './modules/share';
import Search from './modules/search.js';
import { Favorites } from './modules/favorites';

// over sized
import AutoComplete from './modules/autocomplete';
import AutoCompleteV2 from './modules/autocompletev2';
import AutoCompleteV2Inner from './modules/autocompletev2-inner';
import PropertyAutoComplete from './modules/property-autocomplete';
import { PageHeader } from './modules/page-header';

// Global object to hold initialized modules
const initializedModules = {
    MainNav,
    Share,
    Search,
    Favorites,

    AutoComplete,
    AutoCompleteV2,
    AutoCompleteV2Inner,
    PropertyAutoComplete,
    PageHeader,
};

// Helper function to dynamically import modules and initialize them
const importModule = (selectors, modulePath, onLoad) => {
    // Check if any of the selectors are found in the document
    const element = Array.isArray(selectors)
        ? selectors
              .map((selector) => document.querySelector(selector))
              .find((el) => el)
        : document.querySelector(selectors);

    if (element) {
        import(/* webpackChunkName: "[request]" */ `${modulePath}`)
            .then((module) => {
                // Store the initialized module in the global object
                const moduleName = modulePath
                    .split('/')
                    .pop()
                    .replace('.js', '');
                initializedModules[moduleName] = module;

                // Call onLoad with the module and element
                onLoad(module, element);
            })
            .catch((err) => {
                console.error(
                    `Error while loading module from ${modulePath}:`,
                    err
                );
            });
    }
};
(($) => {
    if (window.innerWidth < 992) {
        const input = document.querySelector('input');
        input.addEventListener('click', function (e) {
            setTimeout(() => {
                this.focus();
            }, 200); // Adjust as needed for Android quirks
        });
    }

    // Initialize static modules
    Object.values(initializedModules).forEach((module) => {
        if (typeof module.init === 'function') {
            module.init();
        }
    });

    // if (!document.querySelector('.single-windsor_properties')) {
    //     importModule('.map-explore', './modules/map-explore', (module) => {
    //         module.ExploreMap.init();
    //     });
    // }

    // Initialize dynamic modules
    // In page filter
    importModule(
        ['.in-page-filter', '.single-locations .filter-wrapper'],
        './modules/single-locations',
        (module) => {
            module.SingleLocations.init();
        }
    );

    // video embed
    importModule('.video-embed', './modules/video', (module) => {
        module.Video.init();
    });

    // privacy policy
    importModule('.privacy-policy', './modules/privacy-policy', (module) => {
        module.PrivacyPolicy.init();
    });

    // Testimonial Slider
    importModule(
        '.wc-testimonial__slider',
        './modules/wc-testimonial-slider',
        (module) => {
            module.wcTestimonialSlider.init();
        }
    );

    // text-image-slider-text
    importModule(
        '.text-image-slider-text',
        './modules/text-image-slider',
        (module) => {
            module.TextImageSlider.init();
        }
    );

    // .Jobs
    importModule('.searchandfilter', './modules/jobs', (module) => {
        module.Jobs.init();
    });

    // employee-quote-slider
    importModule(
        '.employee-quote-slider',
        './modules/employee_quote_slider',
        (module) => {
            module.EmployeeQuotesSlider.init();
        }
    );

    // thumbnail-component-slider
    importModule(
        '.thumbnail-component-slider',
        './modules/slider',
        (module, element) => {
            module.Slider.init();
            element.classList.remove('slider-hidden');
        }
    );

    // THUMBNAIL SLIDER
    importModule(
        '.thumb-nail-slider',
        './modules/thumbnail-slider',
        (module) => {
            module.ThumbnailSlider.init();
        }
    );

    // COMMUNITY SLIDER
    importModule(
        '.community-slider',
        './modules/community-slider',
        (module, element) => {
            module.CommunitySlider.init();
            element.classList.remove('slider-hidden');
        }
    );

    // MetroArea
    importModule(
        ['.metro-area', '.neighborhood'],
        './modules/metro-area',
        (module) => {
            module.MetroArea.init();
        }
    );

    // ------------------------------------------------------------------

    // MEDIA GALLERY SLIDER
    importModule(
        '.media-slider',
        './modules/media-gallery-slider',
        (module) => {
            module.MediaGallerySlider.init();
            document.querySelectorAll('.media-slider').forEach((slider) => {
                slider.classList.remove('slider-hidden');
            });
        }
    );

    // sgt-video
    importModule('#play-button', './modules/sgt-video', (module) => {
        module.SgtVideo.init();
    });

    // back to top
    importModule('.wc_backToTop', './modules/backToTop', (module) => {
        module.backToTop.init();
    });

    // Accessibility
    importModule(
        '.single-windsor_properties',
        './modules/accessibility',
        (module) => {
            module.PropertiesAccessibility.init();
        }
    );

    // MEDIA GALLERY FILTER
    importModule(
        '.media-filter-container',
        './modules/media-gallery-filter',
        (module) => {
            module.MediaGalleryFilter.init();
        }
    );

    // .accolade-slider
    importModule(
        '.accolade-slider',
        './modules/accolade_slider',
        (module, element) => {
            module.AccoladeSlider.init();
            element.classList.remove('slider-hidden');
        }
    );

    // .tabs
    importModule('.tabs', './modules/tabs', (module) => {
        module.Tabs.init();
    });

    // .panel
    importModule('.panel', './modules/accordion', (module) => {
        module.Accordion.init();
    });

    //Book a tour
    importModule('.book_a_tour_btn', './modules/modal-book-tour', (module) => {
        module.BookTourModal.init(); // Initialize module when it's loaded
    });

    // .social-container
    importModule('.social-container', './modules/social-wall', (module) => {
        module.SocialWall.init();
    });

    // SelectState
    importModule(
        ['.select-state', '.back-to-states', '.state-thumbnail-container'],
        './modules/selectState',
        (module) => {
            module.SelectState.init();
        }
    );

    // .wc-dropdown-js
    importModule('.wc-dropdown-js', './modules/wc-dropdown', (module) => {
        module.WcDropdown.init();
    });

    // blog-cat__wrapper
    importModule('.blog-cat__wrapper', './modules/blog', (module) => {
        module.Blogs.init();
    });

    // .image-slider
    importModule(
        ['.image-slider', '.js-wc_slider'],
        './modules/image-slider',
        (module) => {
            module.ImageSlider.init();
        }
    );

    // FEATURED CONTENT SLIDER
    importModule(
        '.featured-content-slider',
        './modules/featured-content-slider',
        (module) => {
            module.FeaturedContentSlider.init();
        }
    );

    // CONTACT US
    importModule(
        [
            '.single-locations',
            '.single-windsor_properties',
            '.home',
            '.email_us_btn',
            '.page-template-template-property-sub-page',
        ],
        './modules/modal-property-contact',
        (module) => {
            module.ModalPropertyContact.init();
        }
    );

    // SINGLE PROPERTY
    if (
        document.querySelector('.single-windsor_properties') ||
        document.querySelector('.page-template-template-property-sub-page')
    ) {
        // Array to store all dynamic import promises
        const importPromises = [];

        // Dynamically import each module and push the promise to the array
        importPromises.push(
            import(
                /* webpackChunkName: "single-property" */ './modules/single-property'
            )
        );
        importPromises.push(
            import(
                /* webpackChunkName: "modal-floorplan" */ './modules/modal-floorplan'
            )
        );

        // Wait for all imports to resolve
        Promise.all(importPromises)
            .then((modules) => {
                // Modules array contains the resolved modules
                // You can access and use the modules as needed
                modules.forEach((module) => {
                    // Assuming each module has an init method on the exported object
                    Object.values(module).forEach((exportedObject) => {
                        if (typeof exportedObject.init === 'function') {
                            exportedObject.init();
                        }
                    });
                });
            })
            .catch((err) => {
                console.error('Failed to load modules', err);
            });
    }

    const loadNearbyProperties = () => {
        const communityNearbyContainer = document.querySelector(
            '.community-nearby-container'
        );
        const postIdElement = document.getElementById('postId');
        let sliderName = $('body').hasClass('gallery-page')
            ? 'media_community_slider'
            : 'community_slider';

        if (communityNearbyContainer && postIdElement) {
            const postId = postIdElement.value;
            const fetchUrl = `/wp-content/themes/wincommunities/ajax-nearby-properties.php?post_id=${postId}&slider_name=${sliderName}`;
            fetch(fetchUrl)
                .then((response) => response.text())
                .then((data) => {
                    communityNearbyContainer.innerHTML =
                        decodeHTMLEntities(data);

                    // Using importModule to initialize the required modules
                    // THUMBNAIL SLIDER
                    importModule(
                        '.thumb-nail-slider',
                        './modules/thumbnail-slider',
                        (module) => {
                            module.ThumbnailSlider.init();
                        }
                    );

                    // COMMUNITY SLIDER
                    importModule(
                        '.community-slider',
                        './modules/community-slider',
                        (module, element) => {
                            module.CommunitySlider.init();
                            element.classList.remove('slider-hidden');
                        }
                    );

                    Favorites.updateIsFavClasses();
                })
                .catch((error) => {
                    console.error('Error:', error);
                });
        }
    };
    function decodeHTMLEntities(str) {
        const textarea = document.createElement('textarea');
        textarea.innerHTML = str;
        return textarea.value;
    }
    const loadAboutNeighborhood = () => {
        const aboutNeighborhoodContainer = document.querySelector(
            '.about-neighborhood-container'
        );
        const postIdElement = document.getElementById('postId');

        if (aboutNeighborhoodContainer && postIdElement) {
            const postId = postIdElement.value;
            const fetchUrl = `/wp-content/themes/wincommunities/ajax-about-neighborhood.php?post_id=${postId}`;
            fetch(fetchUrl)
                .then((response) => response.json())
                .then((data) => {
                    if (data && data.content) {
                        window.explore = data.explore;
                        aboutNeighborhoodContainer.innerHTML = data.content;
                        if (window.explore) {
                            importModule(
                                '.wc-dropdown-js',
                                './modules/wc-dropdown',
                                (module) => {
                                    module.WcDropdown.init();
                                }
                            );
                            importModule(
                                '.map-explore',
                                './modules/map-explore',
                                (module) => {
                                    module.ExploreMap.init();
                                }
                            );
                        }
                    } else {
                        console.error(
                            'Expected content not found in the response'
                        );
                    }
                })
                .catch((error) => {
                    console.error('Error:', error);
                });
        }
    };

    const loadNeighborhoodMap = () => {
        const poiMap = document.getElementById('poi-map');

        if (poiMap) {
            poiMap.id = 'explore_map';
            poiMap.className = 'w-full h-[500px]';

            if (window.explore) {
                importModule(
                    '.wc-dropdown-js',
                    './modules/wc-dropdown',
                    (module) => {
                        module.WcDropdown.init();
                    }
                );
                importModule(
                    '.map-explore',
                    './modules/map-explore',
                    (module) => {
                        module.ExploreMap.init();
                    }
                );
            }
        }
    };

    const loadMetroAreaMap = () => {
        const metroMap = document.getElementById('metro-locations-map');

        if (metroMap) {
            importModule(
                '.mapboxgl-map',
                './modules/metro-area-map',
                (module) => {
                    module.MetroAreaMap.init();
                }
            );
        }
    };

    const loadNeighborhoodSightMap = () => {
        const neighborhoodSightMap =
            document.getElementById('sightmap-container');

        if (neighborhoodSightMap) {
            importModule(
                '#sightmap-container',
                './modules/neighborhood-sightmap',
                (module) => {
                    module.NeighborhoodSightMap.init();
                }
            );
        }
    };

    $(document).on('keyup', function (e) {
        if ($('.sr-only').is(':focus')) {
            var code = e.keyCode ? e.keyCode : e.which;
            if (code == 9) {
                $(this).css('display', 'block');
            } else {
                $(this).css('display', 'none');
            }
        }
    });

    setTimeout(() => {
        var host = document.querySelector('.meetelise-chat');
        var style = document.createElement('style');

        style.innerHTML =
            '.launcherContainer.launcher__mobile { height: auto !important; }';
        if (host) {
            host.shadowRoot.appendChild(style);
        }
    }, 1000);

    // Callback function for Intersection Observer
    function handleIntersection(entries, observer) {
        entries.forEach((entry) => {
            if (entry.isIntersecting) {
                if (
                    entry.target.classList.contains(
                        'community-nearby-container'
                    )
                ) {
                    loadNearbyProperties();
                } else if (
                    entry.target.classList.contains(
                        'about-neighborhood-container'
                    )
                ) {
                    loadAboutNeighborhood();
                } else if (
                    entry.target.classList.contains('map-explore__map')
                ) {
                    loadNeighborhoodMap();
                } else if (
                    entry.target.classList.contains(
                        'flex-content--metro_area_map'
                    )
                ) {
                    loadMetroAreaMap();
                } else if (
                    entry.target.classList.contains('metro-mapList__map')
                ) {
                    loadNeighborhoodSightMap();
                }
                // unobserve the element after it has been loaded
                observer.unobserve(entry.target);
            }
        });
    }

    // Create an Intersection Observer instance
    const observer = new IntersectionObserver(handleIntersection, {
        root: null,
        rootMargin: '0px',
        threshold: 0,
    });

    if (document.querySelector('.single-windsor_properties')) {
        const nearbyContainer = document.querySelector(
            '.community-nearby-container'
        );
        const neighborhoodContainer = document.querySelector(
            '.about-neighborhood-container'
        );

        observer.observe(nearbyContainer);

        observer.observe(neighborhoodContainer);
    }

    if (document.body.classList.contains('neighborhood')) {
        const neighborhoodMapContainer =
            document.querySelector('.map-explore__map');

        const metroAreaMapContainer = document.querySelector(
            '.flex-content--metro_area_map'
        );

        const sightmapSection = document.getElementById('mapView');

        observer.observe(neighborhoodMapContainer);

        observer.observe(metroAreaMapContainer);

        observer.observe(sightmapSection);
    }

    if (document.body.classList.contains('metro-area')) {
        const metroAreaMapContainer = document.querySelector(
            '.flex-content--metro_area_map'
        );

        observer.observe(metroAreaMapContainer);
    }
})(jQuery);
